import * as React from 'react';
import appService from '../../../Service';
import {showCustomDialog, showErrorDialog, showSuccessDialog,closeDialog,Input,Form,showLoading,Util} from 'baziigram';
import {useSelector, useDispatch} from 'react-redux'
import {persist} from "../../../redux/actions"
import {useForm} from "react-hook-form";
import  "../styles.css";
import {
    GAME_USER_PROFILE_ACTION_CLEAR,
    GAME_USER_PROFILE_ACTION_PERSIST
} from "../../../redux/GameUserProfile/gameUserProfile.constant";
import  {STORAGE_KEY} from "../../../constants";
import {dictionary} from "../../../constants"
import {profileDictionary} from "../../../constants/profile.js"
import {useEffect} from "react";

const EditDialog = ({language}) => {


    const {formData , user} = useSelector(state =>  state.gameUserProfile)
    const dispatch = useDispatch();
    const form = useForm({defaultValues:{...formData},shouldFocusError: true});
    const {setValue,reset} = form

    const updateState = (state) => {
        dispatch(persist(state, GAME_USER_PROFILE_ACTION_PERSIST))
    }



    const onError=(error)=>{
        window.dispatchEvent(new CustomEvent("baziigram-invalid-input"));
    }

    useEffect(()=>{
    reset({...formData})
    },[])

    const handleSubmit = (data , error) => {
        showLoading(true)
        appService.GameEditProfile(formData.logo,formData.name).then(res => {
        closeDialog("editProfileModal")
        let u = {...user,...{logo:formData.logo, name:formData.name}}
        updateState({user:u})
        showSuccessDialog(profileDictionary.successEdit[language],dictionary.success[language])
           }).catch(err => {
            showErrorDialog(err.message || err)
        }).finally(res => {
            showLoading(false)
        })
    }



    const changeValue = (id, value) => {
        formData[id] = value
        updateState({formData})
         if(id=="logo"){
        try{
        closeDialog()
         }catch(err){}
         }
    }



    const showProfileImages=()=>{
        let body = <div className="text-center d-flex flex-column py-3">
            <div className={"w-100"}><button
                type="button"
                className="close my-2 mr-4"
                data-dismiss="modal"
                aria-label="Close"
                onClick={()=>{
                closeDialog()
                setTimeout(showEditDialog,550)}}
            >
                <span aria-hidden="true">&times;</span>
            </button></div>
            <div className="text-center  rtl ">
                <div className=" d-flex flex-row-justify-content-center">
                    <img onClick={()=>changeValue("logo",1)}  src="/images/profileImages/1.png"
                         className="profileImage"/>
                        <img onClick={()=>changeValue("logo",3)} src="/images/profileImages/3.png"
                             className="profileImage"/>
                            <img onClick={()=>changeValue("logo",4)}
                                 src="/images/profileImages/4.png" className="profileImage"/>
                </div>
                <div className=" d-flex flex-row-justify-content-center">
                    <img onClick={()=>changeValue("logo",5)} src="/images/profileImages/5.png"
                         className="profileImage"/>
                        <img onClick={()=>changeValue("logo",6)} src="/images/profileImages/6.png"
                             className="profileImage"/>
                            <img onClick={()=>changeValue("logo",7)}
                                 src="/images/profileImages/7.png" className="profileImage"/>
                </div>
                <div className=" d-flex flex-row-justify-content-center">
                    <img onClick={()=>changeValue("logo",8)} src="/images/profileImages/8.png"
                         className="profileImage"/>
                        <img onClick={()=>changeValue("logo",9)} src="/images/profileImages/9.png"
                             className="profileImage"/>
                            <img onClick={()=>changeValue("logo",10)}
                                 src="/images/profileImages/10.png" className="profileImage"/>
                </div>
                <div className=" d-flex flex-row-justify-content-center">
                    <img onClick={()=>changeValue("logo",11)} src="/images/profileImages/11.png"
                         className="profileImage"/>
                        <img onClick={()=>changeValue("logo",12)}
                             src="/images/profileImages/12.png" className="profileImage"/>
                </div>
            </div>

            </div>

        showCustomDialog(body)
    }

const endClose=(e)=>{
  if(e.animationName=="hide-dialog")
    {document.getElementById("editProfileModal").classList.remove("hide-dialog");
    document.getElementById("editProfileModal-container").style.display="none"
    }

  }

    return ( <div className="dialog-container" id="editProfileModal-container">
    <div className="dialog-content" id="editProfileModal" onAnimationEnd={endClose} >
    <div className={"ltr d-flex flex-row justify-content-between  mx-3"}><button
                                   type="button"
                                   className="close my-2 mr-4"
                                   data-dismiss="modal"
                                   aria-label="Close"
                                   onClick={()=>{
                                   closeDialog("editProfileModal")
                                   updateState({formData:{name:user.name,logo:user.logo}})
                                   }}
                               >
                                   <span aria-hidden="true">&times;</span>
                               </button></div>
    <div  className={"mx-2 ltr d-flex flex-row justify-content-between align-items-center rtl"}>

                   <div style={{maxWidth:"350px"}} className="d-flex m-auto flex-column justify-content-center  h-100 flex-fill">

                          <Form formClassName="border-0 p-0" buttonTitle={dictionary.ok[language]} form={form}  onError={onError} onSubmit={handleSubmit} >

                                           <div className={"mt-0 d-flex flex-column justify-content-center"}>
                                               <div className={" w-100 align-items-start justify-content-center "}>
                                                   <div className={"col-12  my-2"}>
                                                       <img onClick={showProfileImages}   style={{display:"block"}} width={"70px"} height={"70px"} className={"mx-auto"} src={`/images/profileImages/${formData.logo}.png`}/>
                                                  <div style={{fontSize:"0.9rem"}} className={"text-center text-secondary mb-3"}>{profileDictionary.changeImage[language]}</div>
                                                   </div>
                                                   <div className={"col-12  my-2"}>
                                                       <Input
                                                           form={form}
                                                           label={dictionary.name[language]}
                                                           className="form-control"
                                                           inputLabelClass="bg-light"
                                                           maxLength={30}
                                                           type={"text"}
                                                           id={"name"}
                                                           required={true}
                                                           value={formData.name}
                                                           validator={(value)=>{ return value.length>0}}
                                                           onChange={(id, value) =>
                                                               changeValue(id, value)
                                                           }
                                                       />
                                                   </div>
                                                </div>
                                           </div>
                                       </Form>
                                   </div>
                                 </div></div>
                                 </div>

    );
};

export default EditDialog;


export const showEditDialog=()=>{
document.getElementById("editProfileModal-container").style.display="block"
 setTimeout(function(){document.getElementById("editProfileModal").classList.add("show-dialog")},100)
}

